<template lang="pug">
v-tab-item
    feathers-vuex-find(
        service="bh-survey-options"
        :query="dataQuery"
        :fetch-query="fetchQuery"
        watch="query"
    )
        v-card(slot-scope="{ items: questions, pagination: serverPagination, isFindPending }")
            v-card-title Campaign Survey Manager
                v-spacer
            v-data-table(
                :headers="headers"
                :loading="isFindPending"
                :items="isFindPending ? [] : questions"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                loading-text="Fetching Data..."
            )
                template(v-slot:item.title="{ item }") {{ item.title }}
                template(v-slot:item.type="{ item }") {{ item.type }}
                template(v-slot:item.actions="{ item }")
                    update-campaign-survey(:item="item" @success="success = true")

    v-snackbar(top v-model="success" color="success") Successfully Saved!
    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close
            
</template>

<script>
import UpdateCampaignSurvey from './UpdateCampaignSurvey.vue';

export default {
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id',
                    width: 100
                },
                {
                    text: 'Question (Title)',
                    align: 'start',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: 'Type',
                    align: 'start',
                    sortable: false,
                    value: 'type',
                    width: 150
                },
                {
                    text: 'Actions',
                    sortable: false,
                    align: 'end',
                    value: 'actions',
                    width: 150
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['id'],
                sortDesc: [false]
            },
            query: {
                is_campaign_survey: 1
            },
            error: {
                show: false,
                message: ''
            },
            success: false
        };
    },
    computed: {
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        }
    },
    methods: {
        onError(message) {
            this.error.message = message;
            this.error.show = true;
        }
    },
    components: {
        UpdateCampaignSurvey
    }
}
</script>
